import React from 'react';
import { Switch } from 'antd';
import { useLocaleStore } from '@/i18n';
import './line.less';
import { isNull, isUndefined } from 'lodash';
import { IMarkupLayerProps, MarkupType } from '@meitu/saas-editor-core/es/version-types';
import LabelAction from '@meitu/saas-editor-ui/es/components/label-action';
import { useListenActivePickLayerProps } from '@meitu/saas-editor-ui/es/hooks/use-listen-layer-props';
import { editor } from '@/instance';

export const LineFeature: React.FC<{
    id?: string;
    onAfterChange?: Function;
    trackCode?: string | number;
}> = React.memo(({ id, onAfterChange, trackCode }) => {
    const { $t } = useLocaleStore();

    const needListener = !isUndefined(id);
    const res = useListenActivePickLayerProps(
        editor,
        (layer) => {
            if (!layer) return null;
            const { hasLine, markupType } = layer.data as IMarkupLayerProps;
            return {
                hasLine,
                markupType,
            };
        },
        true,
        needListener,
    );

    if (isNull(res)) return null;

    const { hasLine, markupType } = res;
    if (markupType === MarkupType.Segment) return null;

    return (
        <div className="c-markup-panel__item">
            <LabelAction title={$t((v) => v.panel.markupPanel.line)} align={true}>
                <Switch
                    checked={hasLine}
                    onChange={async () => {
                        if (id) {
                            editor.markupLayer.setLine(id, !hasLine);
                        }
                        onAfterChange?.(trackCode);
                    }}
                />
            </LabelAction>
        </div>
    );
});
